import React from 'react';
import { I18n } from 'react-redux-i18n';
import _ from 'lodash';
import OneClickButton from '../../../../components/form/button';
import Table from '../../../../components/table/Table';

export default class StorageAddressTable extends React.Component {
  constructor(props) {
    super(props);

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.state = {
      page: 0,
      pageSize: 10,
      pages: this.props.pages || 0,
      totalDataLength: this.props.totalDataLength || 0,
      sorted: [],
      filtered: [],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 75,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 75,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE279' /* Setor */),
        accessor: 'sector',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 50,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE121' /* Rua */),
        accessor: 'street',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 50,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE281' /* Coluna */),
        accessor: 'column',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 50,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE283' /* Nível */),
        accessor: 'level',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 50,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE285' /* Gaveta */),
        accessor: 'drawer',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 50,
        Filter: this.filterColumn,
      },
    ];

    this.actionColumn = {
      Header: I18n.t('BEE55' /* Ações */),
      accessor: 'action',
      style: { overflow: 'visible', alignSelf: 'center' },
      filterable: false,
      sortable: false,
      width: 100,
      Cell: (rows) => (
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className="btn btn-default btn-xs"
            onClick={() => this.props.selectAddress(rows.row._original)}
          >
            {I18n.t('BEE608' /* Desvincular */)}

          </button>
        </div>
      ),
    };
  }

  filterColumn = ({ filter, onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  getRangeAddress = async () => {
    const {
      page, pageSize, filtered, sorted,
    } = this.state;
    const data = await this.props.getRangeAddress({
      rangeCode: this.props.rangeCode,
      page,
      pageSize,
      filtered,
      sorted,
    });

    if (data) {
      this.setState({
        pages: data.pages,
        totalDataLength: data.totalDataLength,
      });
    }
  };

  componentDidMount() {
    if (this.props.executeFunction) {
      this.getRangeAddress();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rangeCode !== this.props.rangeCode) {
      this.setState({
        page: 0,
        filtered: [],
        sorted: this.defaultSorted,
      }, () => {
        this.getRangeAddress();
      });
    }

    if (this.props.pages !== prevProps.pages || this.props.totalDataLength !== prevProps.totalDataLength) {
      this.setState({
        pages: this.props.pages || 0,
        totalDataLength: this.props.totalDataLength || 0,
      });
    }
  }

  render() {
    const {
      storageAddresses, title, showAddressLinkBtn,
      openAddressLinkModal, openAddressUnlinkModal, rangeAddressList = [],
    } = this.props;

    const { pages = 0, totalDataLength = 0 } = this.state;

    const columns = showAddressLinkBtn
      ? [this.actionColumn, ...this.tableColumns]
      : this.tableColumns;

    const data = this.props.executeFunction === true ? rangeAddressList : storageAddresses;

    return (
      <div className="table-responsive">
        <Table
          headerTitle={title}
          data={data}
          totalDataLength={totalDataLength}
          columns={columns}
          expander
          filterable
          panelHeaderProps={{ noButton: true }}
          defaultPageSize={this.state.pageSize}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual={this.props.executeFunction === true}
          pages={pages}
          onFetchData={(state) => {
            if (!this.props.getRangeAddress) {
              return;
            }

            const tableParams = {
              rangeCode: this.props.rangeCode,
              page: state.page,
              pageSize: state.pageSize,
              filtered: state.filtered,
              sorted: state.sorted,
            };

            if (this.props.onTableParamsChange) {
              this.props.onTableParamsChange(tableParams);
            }

            this.setState({
              page: state.page,
              pageSize: state.pageSize,
              filtered: state.filtered,
              sorted: state.sorted,
            }, () => {
              this.getRangeAddress();
            });
          }}
          actionButtons={(
            showAddressLinkBtn
            && (
              <div className="ml-auto">
                <OneClickButton
                  type="button"
                  className="btn btn-240 btn-danger btn-rounded pr-3 mr-3"
                  onClick={() => openAddressUnlinkModal()}
                >
                  <i className="fa fa-unlink mr-1" />
                  {I18n.t('BEE607' /* Desnvincular Endereços */)}

                </OneClickButton>
                <OneClickButton
                  type="button"
                  className="btn btn-240 btn-success btn-rounded pr-3"
                  onClick={() => openAddressLinkModal()}
                >
                  <i className="fa fa-link mr-1" />
                  {I18n.t('BEE595' /* Gerar vínculo com endereços */)}

                </OneClickButton>
              </div>
            )
          )}
        />
      </div>
    );
  }
}
